import React from "react";
import PropTypes from "prop-types";
import { Result, Button, Typography } from "antd";

const { Paragraph } = Typography;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("App Error:", error, errorInfo);
  }

  render() {
    const { navigate, children } = this.props;

    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            padding: "20px",
            backgroundColor: "#f0f2f5",
          }}
        >
          <Result
            status="error"
            title="Something went wrong"
            subTitle={
              <>
                <Paragraph>
                  {this.state.error?.message || "An unexpected error occurred."}
                </Paragraph>
                <Paragraph>
                  Please contact the respective person/administrator if the issue persists.
                </Paragraph>
              </>
            }
            extra={
              <Button type="primary" onClick={() => navigate("/home")}>
                Go to Home
              </Button>
            }
          />
        </div>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  navigate: PropTypes.func.isRequired,
};

export default ErrorBoundary;
